import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { BaseComponent } from '../../../base/base.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-bool-option',
  imports: [SelectOptionComponent],
  template: `
    <app-select-option
      [label]="label"
      [control]="control"
      [optionValue]="null"
      [showList]="false"
      [items]="alerts.boolItems"
      [multiple]="false"
      [filter]="false"
      selectLabel=""
      [virtualScroll]="false"
    />
  `,
  styles: ``,
})
export class BoolOptionComponent extends BaseComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  label: string;

  @Input()
  control: FormControl<any>;

  async ngOnInit() {
    if (this.control.value == null) {
      this.control.setValue(this.alerts.find(this.alerts.boolItems, true));
    }
  }
}
